import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Context from '../../../App/MainProvider/context';
import MissionContext from '../MissionContext';
import Button from '../../../../shared/components/Button';
import SpinnerArea from '../../../../shared/components/SpinnerArea';
import missionsService from '../../../../services/missionsService';
import Table, { Cell } from '../../../../shared/components/Table';
import { dateStr, isDraft } from '../../../../shared/misc/utils';
import { Modal } from '../../../../shared/components';
import Role from '../../../../types/role';
import Library from '../../../../shared/components/Library';
import { LibraryAttachment } from '../../../../services/types/LibraryBase';
import { MissionDocument } from '../../../../services/types/Missions';

const MissionDocuments: React.FC = () => {
  const { t } = useTranslation();
  const { service, inSuperUserMode, user } = useContext(Context);
  const {
    data: { mission },
    reload,
  } = useContext(MissionContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false);
  const [documentIdSelected, setDocumentIdSelected] = useState<number | null>(null);

  const download = (docId: number) => {
    service(() => missionsService.downloadAttachment(mission.id, docId), {
      loader: setIsSubmitting,
    });
  };

  const historyCells: Cell<MissionDocument>[] = [
    {
      name: 'createdBy',
      value: (x) => x.createdBy,
    },
    {
      name: 'createdOn',
      column: 'date',
      value: (x) => dateStr(x.createdOn),
    },
    {
      name: 'comment',
      value: (x) => x.comment,
      column: 'comments',
    },
    {
      column: 'attachments',
      // css: 'text-right',
      render: (_, obj) =>
        obj.attachments.length > 0 ? (
          <Button
            className="btn-tertiary no-padding"
            icon="file"
            text=""
            onClick={() => {
              setDocumentIdSelected(obj.id);
              setShowAttachmentsModal(true);
            }}
          />
        ) : (
          <></>
        ),
    },
  ];

  const attachmentCells: Cell<LibraryAttachment>[] = [
    {
      name: 'documentName',
      value: (x) => x.documentName,
    },
    {
      column: 'download',
      css: 'text-right',
      render: (_, obj) => (
        <Button
          className="btn-tertiary no-padding"
          icon="file-download"
          text=""
          onClick={() => download(obj.id)}
        />
      ),
    },
  ];

  const canSave =
    (mission.operation.isMember ||
      user.roleCode === Role.HSO ||
      user.roleCode === Role.GroupHead ||
      inSuperUserMode()) &&
    !isDraft(mission.operation);

  return (
    <SpinnerArea loading={isSubmitting}>
      {canSave && (
        <Library
          id={mission.id}
          reload={reload}
          docService={missionsService}
          savedComment={mission.documentDraft ? mission.documentDraft.comment : undefined}
        />
      )}

      <h5>{t('history')}</h5>
      <Table data={mission.documents} cells={historyCells} keyFunc={(x) => x.id} emptyNoDesc />
      <Modal
        visible={showAttachmentsModal}
        setVisible={() => {
          setShowAttachmentsModal(false);
        }}
        title={t('attachments')}
        actions={[{ text: t('close'), action: () => {} }]}
        customClass="wide-modal"
      >
        <div className="history-content flow-history table-responsive">
          {documentIdSelected && (
            <Table
              data={mission.documents.filter((x) => x.id === documentIdSelected)[0].attachments}
              cells={attachmentCells}
              keyFunc={(x) => x.id}
              emptyNoDesc
            />
          )}
        </div>
      </Modal>
    </SpinnerArea>
  );
};

export default MissionDocuments;
